import { AppStateFailureItem } from './app-state.failure.item';
import { ApiResponseCode } from '@symphony-solo/shared/http/src';
import { ErrorCode } from '@symphony-solo/shared/error-handling/src';

export class AppStateFailureItemWithErrorCode extends AppStateFailureItem {
  public errorCode: ApiResponseCode | ErrorCode;

  public constructor(message: string, code: ApiResponseCode | ErrorCode) {
    super(message);
    this.errorCode = code;
  }
}
